import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

const Input = ({ value, onChange, placeholder, setFocus }) => {
  return (
    <Wrapper
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      onBlur={() => setFocus(false)}
    />
  );
};

Input.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
};

Input.defaultProps = {
  setFocus: null,
};

export default Input;
